<script lang="ts" setup>
import { AppLink } from '#components'

const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
  context: {
    type: [Object, Array],
    default: () => null,
  },
})

function getElement(value: any) {
  return value ? AppLink : 'div'
}

function getRatios(file: any) {
  const ratio = {}

  ratio['--ratio-default'] = `${file.width || 7} / ${file.height || 8}`

  return ratio
}

const isText = computed(() => {
  return props.slice?.Marquee?.Items?.every(item => item?.TypeMedia === false)
})
</script>

<template>
  <StrapiSlice
    v-if="slice?.Marquee?.Items?.length"
    :class="
      [
        'ct-marquee',
        {
          'ct-marquee--no-description': !slice?.Marquee?.Description,
          'ct-marquee--text-only': isText,
        },
      ]
    "
    :slice="slice"
    :index="index"
  >
    <div
      v-if="slice?.Marquee?.Description"
      class="ct-marquee__description"
    >
      <StrapiBlocksText
        :nodes="slice.Marquee.Description"
      />
    </div>
    <UiMarquee
      class="ct-marquee__items"
    >
      <div
        v-for="(item) in slice.Marquee.Items"
        :key="item"
        class="ct-marquee__item"
      >
        <component
          :is="getElement(item?.Link)"
          v-if="item?.TypeMedia === true && item?.Media"
          v-bind="item?.Link ? { to: item.Link } : {}"
          class="ct-marquee-item__image"
          :style="getRatios(item.Media)"
        >
          <img
            :src="useXcdnImage(item.Media.url, 'f=rs:fit:400')"
            :alt="item.Media.alternativeText || ''"
            :height="item.Media.height"
            :width="item.Media.width"
            loading="lazy"
            fetchpriority="auto"
            decoding="async"
          >
        </component>
        <div
          v-if="item?.TypeMedia === false && item?.Text?.length > 0"
          class="ct-marquee-item__text"
        >
          <StrapiBlocksText
            :nodes="[item.Text[0]]"
          />
        </div>
      </div>
    </UiMarquee>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/Marquee.css");
</style>
